import { apiClient } from './client';

export interface AIUsageSummary {
    currentWindow: {
        totalTokens: number;
        promptTokens: number;
        completionTokens: number;
        requestCount: number;
        limit: number;
        remaining: number;
        percentUsed: number;
    };
    lifetime: {
        totalTokens: number;
        promptTokens: number;
        completionTokens: number;
        estimatedCostUsd: number;
        totalRequests: number;
    };
    dailyBreakdown: Array<{
        date: string;
        totalTokens: number;
        promptTokens: number;
        completionTokens: number;
        estimatedCostUsd: number;
        requestCount: number;
    }>;
    recentLogs: Array<{
        id: string;
        model: string;
        promptTokens: number;
        completionTokens: number;
        totalTokens: number;
        estimatedCostUsd: number;
        durationMs: number;
        toolCallCount: number;
        createdAt: string;
        conversationId: string;
    }>;
    quotaConfig: {
        windowHours: number;
        resetHours: number;
        limit: number;
        planName: string;
        planId: string;
    };
}

export interface AIGlobalSummary {
    thisWeek: {
        totalTokens: number;
        estimatedCostUsd: number;
        totalRequests: number;
    };
    topUsers: Array<{
        userId: string;
        totalTokens: number;
        estimatedCostUsd: number;
        requestCount: number;
        user: {
            id: string;
            name: string | null;
            email: string;
        };
    }>;
}

export const aiUsageApi = {
    getUserUsage: async (userId: string): Promise<AIUsageSummary> => {
        const res = await apiClient.get(`/admin/ai-usage/users/${userId}`);
        return res.data.data;
    },

    getGlobalSummary: async (): Promise<AIGlobalSummary> => {
        const res = await apiClient.get('/admin/ai-usage/summary');
        return res.data.data;
    }
};
